import adminLoadInfo from './admin-load-info';
import companyList from './company-list';
import companyDetail from './company-detail';
import companyForm from './company-form';
import companyAdminList from './company-admin-list';
import companyAdminForm from './company-admin-form';
import companyProfileList from './company-profile-list';
import companyProfileForm from './company-profile-form';
import companyProfileDetail from './company-profile-detail';

export default {
  adminLoadInfo,
  companyList,
  companyDetail,
  companyForm,
  companyAdminList,
  companyAdminForm,
  companyProfileList,
  companyProfileForm,
  companyProfileDetail,
};



// WEBPACK FOOTER //
// ./src/pages/company/index.js